// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData_ContactData__2en0T","Input":"ContactData_Input__2Ezq9"};